import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleAmped19AhNMCWithCharger = () => {
  console.log('🎯 SimpleAmped19AhNMCWithCharger component loading');
  
  const product = findProductById("amped-19ah-nmc-with-charger");
  
  if (!product) {
    console.error('Product not found:', "amped-19ah-nmc-with-charger");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="amped-19ah-nmc-with-charger"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleAmped19AhNMCWithCharger; 